import type { Icon } from '@change/ds-icons';
import {
	CDotIcon,
	ChatBubbleIcon,
	EmailIcon,
	FacebookRegularIcon,
	InstagramIcon,
	LightbulbIcon,
	LineIcon,
	LinkedInIcon,
	LinktreeIcon,
	NextDoorIcon,
	QrCodeIcon,
	RedditIcon,
	SnapchatIcon,
	TelegramIcon,
	TikTokIcon,
	TwitterIcon,
	VkIcon,
	WhatsAppIcon,
	YouTubeIcon,
} from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export const OTHER_CHANNEL_KEY = 'other';

type ChannelSetting = {
	// Social/brand colors use hex values because they are official brand colors
	// from third-party platforms and are deliberately not included in our design tokens.
	iconColor: string;
	translationKey: TranslationKey;
	icon: React.FC<Icon>;
};
export const CHANNEL_SETTINGS: Record<string, ChannelSetting> = {
	change_email: {
		iconColor: 'text-typography-brand',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.change_email',
		),
		icon: EmailIcon,
	},
	email: {
		iconColor: 'text-[#842B8F]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.email',
		),
		icon: EmailIcon,
	},
	facebook: {
		iconColor: 'text-[#1877F2]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.facebook',
		),
		icon: FacebookRegularIcon,
	},
	instagram: {
		iconColor: 'text-[#FF0069]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.instagram',
		),
		icon: InstagramIcon,
	},
	line: {
		iconColor: 'text-[#06C755]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.line',
		),
		icon: LineIcon,
	},
	linkedin: {
		iconColor: 'text-[#0A66C2]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.linkedin',
		),
		icon: LinkedInIcon,
	},
	linktree: {
		iconColor: 'text-[#43E55E]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.linktree',
		),
		icon: LinktreeIcon,
	},
	nextdoor: {
		iconColor: 'text-[#00422D]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.nextdoor',
		),
		icon: NextDoorIcon,
	},
	organic_search: {
		iconColor: 'text-typography-brand',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.organic_search',
		),
		icon: LightbulbIcon,
	},
	other: {
		iconColor: 'text-black',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.other_channel',
		),
		icon: LightbulbIcon,
	},
	promotion: {
		iconColor: 'text-typography-brand',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.promotion',
		),
		icon: CDotIcon,
	},
	qr_code: {
		iconColor: 'text-black',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.qr_code',
		),
		icon: QrCodeIcon,
	},
	reddit: {
		iconColor: 'text-[#FF4500]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.reddit',
		),
		icon: RedditIcon,
	},
	sms: {
		iconColor: 'text-[#528334]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.sms',
		),
		icon: ChatBubbleIcon,
	},
	snapchat: {
		iconColor: 'text-black',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.snapchat',
		),
		icon: SnapchatIcon,
	},
	telegram: {
		iconColor: 'text-[#229ED9]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.telegram',
		),
		icon: TelegramIcon,
	},
	tiktok: {
		iconColor: 'text-black',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.tiktok',
		),
		icon: TikTokIcon,
	},
	twitter: {
		iconColor: 'text-black',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.twitter',
		),
		icon: TwitterIcon,
	},
	vk: {
		iconColor: 'text-[#0077FF]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.vk',
		),
		icon: VkIcon,
	},
	whatsapp: {
		iconColor: 'text-[#25D366]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.whatsapp',
		),
		icon: WhatsAppIcon,
	},
	youtube: {
		iconColor: 'text-[#FF0000]',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.channels.youtube',
		),
		icon: YouTubeIcon,
	},
};
